import React from "react";
import { Field, Formik } from "formik";
import { object } from "yup";
import { TextField } from "formik-material-ui";
import Button from "@material-ui/core/Button/Button";
import Grid from "@material-ui/core/Grid";

const validationSchema = object().shape({});

const handleSubmitting = (fn) => (values, actions) => {
  fn(values);
  actions.setSubmitting(false);
};

export const EstablishmentSEOForm = ({ onSubmit, establishment }) => (
  <Formik
    initialValues={{
      id: establishment.id,
      seo_title: establishment.seo_title,
      seo_text: establishment.seo_text,
      seo_robots: establishment.seo_robots,
    }}
    onSubmit={handleSubmitting(onSubmit)}
    validationSchema={validationSchema}
    validateOnChange={false}
    validateOnBlur={false}
    render={({ values, handleSubmit, setFieldValue, setFieldTouched }) => {
      return (
        <form onSubmit={handleSubmit}>
          <Grid item md={12} className="new-card-inner">
            <Field
              name="seo_title"
              label="Título"
              type="text"
              variant="outlined"
              margin="normal"
              component={TextField}
              onChange={setFieldValue}
              value={"" + values.seo_title}
              multiline={true}
              fullWidth
              rows="1"
            />
          </Grid>
          <Grid item md={12} className="new-card-inner">
            <Field
              name="seo_text"
              label="Descrição"
              type="text"
              variant="outlined"
              margin="normal"
              component={TextField}
              onChange={setFieldValue}
              value={"" + values.seo_text}
              multiline={true}
              fullWidth
              rows="3"
            />
          </Grid>
          <div class="small pl-2 text-secondary font-italic">
            Se não estiver preenchido é usado o campo Descrição
          </div>
          <Grid item md={12} className="new-card-inner">
            <Field
              name="seo_robots"
              label="Robots meta tag"
              type="text"
              variant="outlined"
              margin="normal"
              component={TextField}
              onChange={setFieldValue}
              value={"" + values.seo_robots}
              multiline={true}
              fullWidth
              rows="1"
            />
          </Grid>
          <div class="small pl-2 text-secondary font-italic">
            Se não for definida, irá ser aplicada a meta-tag 'index,follow'
          </div>

          <br />
          <Button
            variant="contained"
            type="submit"
            size="small"
            style={{ marginTop: "20px" }}
          >
            Atualizar
          </Button>
        </form>
      );
    }}
  />
);
